// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import EventPriceSummaryModel from '../../model/event-price-summary-model';
import EventPriceSummaryDTO from '../dto/event-price-summary-dto';
import dtoSchema from '../schemas/event-price-summary-schema';

export default abstract class EventPriceSummaryModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<EventPriceSummaryDTO>) {
    super();
    if (data) {
      this.eventPartyRoleId = data.eventPartyRoleId;
      this.orderTemplateId = data.orderTemplateId;
      this.customerGroupTotalPrices = data.customerGroupTotalPrices ?? undefined;
    }
  }
  /**
  * @type {uuid}
  */
  eventPartyRoleId?: string;
  /**
  * @type {uuid}
  */
  orderTemplateId?: string;
  /**
  */
  customerGroupTotalPrices?: Record<any, number>;

  static toModel(dto: DeepPartial<EventPriceSummaryDTO>): EventPriceSummaryModel;
  static toModel(dto: DeepPartial<EventPriceSummaryDTO> | undefined | null): EventPriceSummaryModel | undefined;
  static toModel(dto: DeepPartial<EventPriceSummaryDTO> | undefined | null): EventPriceSummaryModel | undefined {
    return dto ? new EventPriceSummaryModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<EventPriceSummaryModel> | EventPriceSummaryModel): EventPriceSummaryDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      eventPartyRoleId: unwrapped.eventPartyRoleId,
      orderTemplateId: unwrapped.orderTemplateId,
      customerGroupTotalPrices: unwrapped.customerGroupTotalPrices,
    } as EventPriceSummaryDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for EventPriceSummaryModel, can not map to EventPriceSummaryDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
